import {
  GET_CAMPAIGN_DATA,
  GET_CAMPAIGN_PREVIEW_DATA,
  GET_CAMPAIGN_ACCORDIAN_OPEN_DATA,
  GET_ADD_STRATEGY_DATA,
  BEGIN_AJAX_CALL,
  SHOW_DRAGGER,
  END_AJAX_CALL,
  GET_PREVIEW_CAMPAING_DATA,
  GET_THIRD_PARTY_LIST,
} from "../../constants/actionType";
import {
  postCampaignApi,
  getCampaignApi,
  getThirdPartyAccountApi,
  postTenantDetailsByMandateIdApi,
  getSnapchatCampaignApi,
} from "../../api/campaign";

export const reduxCampaignDataAction =
  ({ data }) =>
    async (dispatch) => {
      try {
        dispatch({
          type: GET_CAMPAIGN_DATA,
          campaignData: data,
        });
      } catch (err) {
      } finally {
      }
    };

export const reduxCampaignPreviewPublishDataAction =
  ({ data }) =>
    async (dispatch) => {
      try {
        dispatch({
          type: GET_CAMPAIGN_PREVIEW_DATA,
          campaignPublishData: data,
        });
      } catch (err) {
      } finally {
      }
    };

export const reduxDataForAccordianOpenCampaignAction =
  ({ data }) =>
    async (dispatch) => {
      try {
        dispatch({
          type: GET_CAMPAIGN_ACCORDIAN_OPEN_DATA,
          campaignAccordianData: data,
        });
      } catch (err) {
      } finally {
      }
    };

export const getThirdPartyAccountAction =
  ({ tenantId, authToken, userId }) =>
    async (dispatch) => {
      let thirdPartyList = {};
      try {
        dispatch({
          type: BEGIN_AJAX_CALL,
          showSpinner: true,
        });
        thirdPartyList = await getThirdPartyAccountApi({
          tenantId,
          authToken,
          userId,
        });
        dispatch({
          type: GET_THIRD_PARTY_LIST,
          thirdPartyList,
        });
        return thirdPartyList;
      } catch (err) {
      } finally {
        dispatch({
          type: END_AJAX_CALL,
          showSpinner: false,
        });
      }
    };

export const reduxDataForPreviewCampaingDataAction =
  ({ data }) =>
    async (dispatch) => {
      try {
        dispatch({
          type: GET_PREVIEW_CAMPAING_DATA,
          previewCampaingData: data,
        });
      } catch (err) {
      } finally {
      }
    };

export const reduxSpinnerAction =
  (value = false) =>
    async (dispatch) => {
      dispatch({
        type: BEGIN_AJAX_CALL,
        showSpinner: value,
      });
    };

export const reduxDrawerAction =
  (value = false) =>
    async (dispatch) => {
      dispatch({
        type: SHOW_DRAGGER,
        draggerData: value,
      });
    };

export const reduxDataForStrategyAction =
  ({ data }) =>
    async (dispatch) => {
      try {
        dispatch({
          type: GET_ADD_STRATEGY_DATA,
          addStrategyData: data,
        });
      } catch (err) {
      } finally {
      }
    };

export const postCampaignAction =
  ({ tenantId, authToken, userId, params = {}, payload = {} }) =>
    async (dispatch) => {
      let campaignResponse = {};
      try {
        dispatch({
          type: BEGIN_AJAX_CALL,
          showSpinner: true,
        });

        campaignResponse = await postCampaignApi({
          tenantId,
          authToken,
          userId,
          params,
          payload,
        });
        return campaignResponse;
      } catch (err) {
      } finally {
        dispatch({
          type: END_AJAX_CALL,
          showSpinner: false,
        });
      }
    };

export const postTenantDetailsByMandateIdAction =
  ({ tenantId, authToken, userId, payload = {} }) =>
    async (dispatch) => {
      let tenantResponse = {};
      try {
        dispatch({
          type: BEGIN_AJAX_CALL,
          showSpinner: true,
        });

        tenantResponse = await postTenantDetailsByMandateIdApi({
          tenantId,
          authToken,
          userId,
          payload,
        });
        return tenantResponse;
      } catch (err) {
      } finally {
        dispatch({
          type: END_AJAX_CALL,
          showSpinner: false,
        });
      }
    };

export const getCampaignAction =
  ({ tenantId, authToken, userId, params = {} }) =>
    async (dispatch) => {
      let campaignResponse = {};
      try {
        dispatch({
          type: BEGIN_AJAX_CALL,
          showSpinner: true,
        });

        campaignResponse = await getCampaignApi({
          tenantId,
          authToken,
          userId,
          params,
        });
        return campaignResponse;
      } catch (err) {
      } finally {
        dispatch({
          type: END_AJAX_CALL,
          showSpinner: false,
        });
      }
    };

export const getSnapchatCampaignAction =
  ({ tenantId, authToken, userId, params = {} }) =>
    async (dispatch) => {
      let campaignResponse = {};
      try {
        dispatch({
          type: BEGIN_AJAX_CALL,
          showSpinner: true,
        });

        campaignResponse = await getSnapchatCampaignApi({
          tenantId,
          authToken,
          userId,
          params,
        });
        return campaignResponse;
      } catch (err) {
      } finally {
        dispatch({
          type: END_AJAX_CALL,
          showSpinner: false,
        });
      }
    };

export const getCampaignActionWithoutLoader =
  ({ tenantId, authToken, userId, params = {} }) =>
    async (dispatch) => {
      let campaignResponse = {};
      try {
        campaignResponse = await getCampaignApi({
          tenantId,
          authToken,
          userId,
          params,
        });
        return campaignResponse;
      } catch (err) {
      } finally {
      }
    };
